import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/BILL_PAYERS';

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(`${domain}/CREATE`, (institutionId, billPayer) => ({institutionId, billPayer}));

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, (institutionId, billPayerId) => ({institutionId, billPayerId}));

export const {
    action: discontinue,
    success: discontinueSuccess,
    failed: discontinueFailed,
} = createAction(
    `${domain}/DISCONTINUE`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    billPayer => ({billPayer}),
);

export const {
    action: revive,
    success: reviveSuccess,
    failed: reviveFailed,
} = createAction(
    `${domain}/REVIVE`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    billPayer => ({billPayer}),
);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, (institutionId, childId) => ({institutionId, childId}));

export const {action: storeExpectedIds} = createAction(`${domain}/STORE_EXPECTED_IDS`, (billPayerId, expectedIds) => ({
    billPayerId,
    expectedIds,
}));

export const {action: storeUnexpectedIds} = createAction(
    `${domain}/STORE_UNEXPECTED_IDS`,
    (billPayerId, unexpectedIds) => ({
        billPayerId,
        unexpectedIds,
    }),
);

export const {
    action: fetchBillPayers,
    success: fetchBillPayersSuccess,
    failed: fetchBillPayersFailed,
} = createAction(`${domain}/FETCH_BILL_PAYERS_FOR_TARGET`, targetId => ({targetId}));

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(`${domain}/UPDATE`, (institutionId, billPayer) => ({institutionId, billPayer}));

export const {
    action: updateSplit,
    success: updateSplitSuccess,
    failed: updateSplitFailed,
} = createAction(`${domain}/UPDATE_SPLIT`, (institutionId, childId, splitConfiguration) => ({
    institutionId,
    childId,
    splitConfiguration,
}));

export const {
    action: addBillPayerToChild,
    success: addBillPayerToChildSuccess,
    failed: addBillPayerToChildFailed,
} = createAction(
    `${domain}/ADD_BILL_PAYER_TO_CHILD`,
    (
        institutionId,
        childId,
        existingChildBillPayers,
        existingChildSplitConfiguration,
        newBillPayerData,
        sensitiveInformation,
    ) => ({
        institutionId,
        childId,
        existingChildBillPayers,
        existingChildSplitConfiguration,
        newBillPayerData,
        sensitiveInformation,
    }),
);

export const {
    action: updateNote,
    success: updateNoteSuccess,
    failed: updateNoteFailed,
} = createAction(
    `${domain}/UPDATE_NOTE`,
    (institutionId, billPayerNoteMap) => ({institutionId, billPayerNoteMap}),
    billPayers => ({billPayers}),
);

export const {
    action: fetchSensitiveInformation,
    success: fetchSensitiveInformationSuccess,
    failed: fetchSensitiveInformationFailed,
} = createAction(
    `${domain}/FETCH_SENSITIVE_INFORMATION`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    (billPayerId, sensitiveInformation) => ({billPayerId, sensitiveInformation}),
);

export const {
    action: updateSensitiveInformation,
    success: updateSensitiveInformationSuccess,
    failed: updateSensitiveInformationFailed,
} = createAction(
    `${domain}/UPDATE_SENSITIVE_INFORMATION`,
    (institutionId, billPayerId, sensitiveInformation) => ({institutionId, billPayerId, sensitiveInformation}),
    () => ({}),
);

export const {action: updateBillPayerCategories} = createAction(
    `${domain}/UPDATE_BILL_PAYER_CATEGORIES`,
    (billPayerId, tags) => ({billPayerId, tags}),
    billPayer => ({billPayer}),
);
